export const initObserver = () => {

    let lazyloadImages;

    if ('IntersectionObserver' in window) {
        lazyloadImages = document.querySelectorAll('.lazy');

        let imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    let image = entry.target;

                    if (image.classList.contains('lazy-bg')) {
                        $(image).css('background-image', 'url(' + image.dataset.src + ')');
                    } else {
                        image.src = image.dataset.src;
                    }

                    image.classList.remove('lazy');
                    imageObserver.unobserve(image);
                }
            });
        });

        lazyloadImages.forEach((image) => {
            imageObserver.observe(image);
        });

    } else {
        let lazyloadThrottleTimeout;
        lazyloadImages = document.querySelectorAll('.lazy');

        function lazyload() {
            if (lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
            }

            lazyloadThrottleTimeout = setTimeout(() => {
                let scrollTop = window.pageYOffset;
                lazyloadImages.forEach((image) => {
                    if (image.offsetTop < (window.innerHeight + scrollTop)) {
                        image.src = image.dataset.src;
                        image.classList.remove('lazy');
                    }
                });
                if (lazyloadImages.length === 0) {
                    document.removeEventListener('scroll', lazyload);
                    window.removeEventListener('resize', lazyload);
                    window.removeEventListener('orientationChange', lazyload);
                }
            }, 20);
        }

        document.addEventListener('scroll', lazyload);
        window.addEventListener('resize', lazyload);
        window.addEventListener('orientationChange', lazyload);
    }

};
